import { Engineer } from '@crimsontide/core/client/interfaces'
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;
let cachedEngineers: Engineer[];

export const EngineerService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getEngineers = async (engineerId?: string, includeParkUser: boolean = false, useCache: boolean = true): Promise<Engineer[]> => {
    if (useCache && engineerId == null && cachedEngineers != null) {
      return await filterEngineers(cachedEngineers, includeParkUser);
    }

    cachedEngineers = await fetch('/api/Engineer/get?' + new URLSearchParams({
      engineerId: engineerId?.toString() ?? '',
    }),
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF': '1',
        }
      }
    ).then(engineers => engineers.json());

    return await filterEngineers(cachedEngineers, includeParkUser);
  };

  const filterEngineers = async (engineers: Engineer[], includeParkUser: boolean) : Promise<Engineer[]> => {
    if (includeParkUser) {
      return engineers;
    } else {
      return engineers.filter(engineer => engineer.engineerId != '00000000-0000-0000-0000-000000000000');
    }
  }

  return {
    setDotNetReference,
    getEngineers,
  };
})();
